/* eslint-disable */

import SSOApiService from "../SSOApiService";

const OTPServices = {

  generateRegisterOTP(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    return SSOApiService.post('api/generate_register_otp/', data, config);
  },

  verifyRegisterOTP(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    return SSOApiService.post('api/verify_register_otp/', data, config);
  },

  generateRegisterOTPSMS(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    return SSOApiService.post('api/generate_register_otp_sms/', data, config);
  },

  verifyRegisterOTPSMS(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    return SSOApiService.post('api/verify_register_otp_sms/', data, config);
  }
};

export default OTPServices;
